// extracted by mini-css-extract-plugin
export default {"container":"container--1MNjPd8","vertical":"vertical--5kExFuy","img":"img--1uWk_e5","text":"text--2hFnNUX"};